var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-custom-input-container"},[_c('p-input-text',{attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"type":_vm.type,"step":_vm.step,"min":_vm.min,"max":_vm.max},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }